import { LocalStorageService } from './store/local-storage';
import { initApiConfig } from "@lookahead/core";

export const initWebConfig = () => {
  const BASE_URL: string = `${process.env.REACT_APP_API_HOST || 'http://localhost:3000'}${process.env.REACT_APP_API_VERSION}`;
  const SHOW_LOG: boolean = false;

  initApiConfig(BASE_URL, LocalStorageService, SHOW_LOG);
};